<template lang="html">
  <div class="kf-player">
    <div class="video-player">
      <template v-if="isInIos">
        <video
          v-show="displayVideo"
          ref="videoPlayer"
          :lazy-src="src"
          preload="metadata"
        ></video>
      </template>
      <template v-else>
        <video
          v-show="displayVideo"
          x5-video-player-type="h5"
          playsinline
          webkit-playsinline="true"
          ref="videoPlayer"
          :lazy-src="src"
          preload="metadata"
        ></video>
      </template>
    </div>
    <div class="video-mask-trigger"></div>
    <div class="video-poster" v-show="!displayVideo">
      <img :src="poster | viewImage(750, 422, undefined, 2)" alt="" />
    </div>
    <div class="video-play-button" v-show="!displayVideo">
      <!-- <div class="iconfont icon-play" ></div> -->
      <img
        src="../../../assets/images/sx_btn_action@3x (1).png"
        @click="clickPlayBtn"
      />
    </div>
    <div class="video-loading" v-show="isLoading">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="2"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    </div>
    <div class="video-error" v-show="isError">
      <p>网络异常，请稍后再试</p>
      <!-- <div class="retry-button">
                <button>重试</button>
            </div> -->
    </div>
    <div class="video-dashboard" v-show="hasDashBoard">
      <div class="video-play" @click="controlPlay">
        <i class="iconfont icon-play" :class="{ 'icon-pause': playing }"></i>
      </div>
      <div class="video-progress">
        <span class="video-playtime">{{ curTime }}</span>
        <div class="video-progress-track">
          <span class="progress-play">
            <i class="seekBtn"></i>
          </span>
        </div>
        <span class="video-alltime">{{ allTime }}</span>
      </div>
      <div class="video-sound" @click="controlSound">
        <i
          class="iconfont icon-yinliang"
          :class="{ 'icon-jingyin': hasMuted }"
        ></i>
      </div>
      <div
        class="video-fullscreen"
        @click="openFullScreen"
        v-show="showFullIcon"
      >
        <i class="iconfont icon-full"></i>
      </div>
    </div>
  </div>
</template>

<script>
import isIOS from '@/plugins/isIOS'
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    track: {
      type: Object,
      default: () => ({})
    },
    // 从外部控制视频播放状态
    canPlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isInIos: isIOS,
      displayVideo: false, // 是否显示视频
      playing: false, // 视频播放状态
      hasPlaying: false, // 是否已经在播放，或者暂停,只在点击播放或者暂停按钮控制
      hasDashBoard: false, // 是否显示控制面板
      curTime: '00:00', // 秒
      allTime: '00:00',
      hasMuted: false, // 是否静音
      timer: null,
      showFullIcon: false, // 是否显示全屏图标
      isLoading: false,
      isError: false
    }
  },
  created() {
    // 判断是否支持全屏
    if (this.isInIos) {
      this.showFullIcon = true
    }
    this.$emit('playing', false)
    this.$emit('x5FullScreen', false)
  },
  watch: {
    canPlay(val) {
      if (this.hasPlaying) {
        if (val) {
          this.play()
        } else {
          this.pause()
        }
      }
    },
    src(val) {
      const v = this.$refs.videoPlayer
      v.currentTime = 0
      this.hideVideo()
      this.hideDashBoard()
      this.playing = false
      this.hasPlaying = false
    },
    displayVideo() {
      this.$emit('showVideo', this.displayVideo)
    }
  },
  mounted() {},
  methods: {
    init() {
      const v = this.$refs.videoPlayer
      const player = v.parentNode.parentNode
      const control_bar = player.querySelector('.video-dashboard')
      const mask_trigger = player.querySelector('.video-mask-trigger')
      v.src = v.getAttribute('lazy-src')
      this.showLoading()
      this.controlPlay()
      v.addEventListener('loadedmetadata', e => {
        this.allTime = this.reverseTime(v.duration)
      })
      v.addEventListener('ended', () => {
        this.over()
        this.playing = false
        this.hasPlaying = false
        // 关闭全屏？
        this.closeFullScreen()
      })
      v.addEventListener('play', () => {
        this.$emit('playing', true)
        this.playing = true
        this.timer = setTimeout(() => {
          if (control_bar) {
            control_bar.classList.add('video-opacity-hidden')
          }
        }, 3000)
      })
      v.addEventListener('pause', () => {
        this.$emit('playing', false)
        this.playing = false
        if (this.timer) {
          clearTimeout(this.timer)
        }
        if (control_bar) {
          control_bar.className = 'video-dashboard'
        }
      })
      v.addEventListener('error', e => {
        this.hideLoading()
        this.hideVideo()
        this.showError()
      })
      // v.addEventListener('stalled', (e) => {
      //     this.hideLoading()
      //     this.hideVideo()
      //     this.showError()
      // })
      v.addEventListener('playing', e => {
        this.hideLoading()
      })
      // 提示该视频已准备好开始播放
      v.addEventListener('loadeddata', e => {
        // this.play()
      })
      v.addEventListener('timeupdate', () => {
        const cur_position = v.currentTime
        const percentage = (100 * cur_position) / v.duration
        const progressBar =
          v.parentNode.parentNode.querySelector('.progress-play')
        if (progressBar) {
          progressBar.style.width = `${percentage}%`
        }
        this.curTime = this.reverseTime(cur_position)
        if (this.allTime === '00:00') {
          this.allTime = this.reverseTime(v.duration)
        }
      })
      // 微信x5全屏
      v.addEventListener('x5videoenterfullscreen', () => {
        this.$emit('x5FullScreen', true)
      })
      // 微信x5退出全屏
      v.addEventListener('x5videoexitfullscreen', () => {
        this.$emit('x5FullScreen', false)
      })
      if (mask_trigger) {
        mask_trigger.addEventListener('click', () => {
          if (this.timer) {
            clearTimeout(this.timer)
          }
          control_bar.className = 'video-dashboard'
          this.timer = setTimeout(() => {
            if (control_bar) {
              control_bar.classList.add('video-opacity-hidden')
            }
          }, 4500)
        })
      }
      if (control_bar) {
        control_bar.addEventListener('transitionend', () => {
          if (control_bar.classList.contains('video-opacity-hidden')) {
            control_bar.classList.add('video-hidden')
          } else {
            control_bar.className = 'video-dashboard'
          }
        })
      }
    },
    reverseTime(seconds) {
      let minutes = Math.floor(seconds / 60)
      if (minutes < 10) {
        minutes = `0${minutes}`
      }
      return `${minutes}:${((seconds % 60) / 100).toFixed(2).slice(-2)}`
    },
    over() {
      this.hideVideo()
      this.hideDashBoard()
    },
    clickPlayBtn() {
      this.init()
      this.showVideo()
      this.showDashBoard()
      if (this.track.pageId) {
        this.$$tracker(
          this.track.pageId,
          this.track.eventType,
          this.track.eventId
        )
      }
    },
    controlPlay() {
      const v = this.$refs.videoPlayer
      if (v.paused || v.ended) {
        // 暂停时点击就播放
        if (v.ended) {
          // 如果播放完毕，就重头开始播放
          v.currentTime = 0
        }
        v.play()
        this.playing = true
        this.hasPlaying = true
      } else {
        v.pause()
        this.playing = false
        this.hasPlaying = false
      }
    },
    play() {
      const v = this.$refs.videoPlayer
      if (v.paused || v.ended) {
        // 暂停时点击就播放
        if (v.ended) {
          v.currentTime = 0
        }
        v.play()
      }
    },
    pause() {
      const v = this.$refs.videoPlayer
      v.pause()
    },
    controlSound() {
      const v = this.$refs.videoPlayer
      if (v.muted) {
        v.muted = false
        this.hasMuted = false
      } else {
        v.muted = true
        this.hasMuted = true
      }
    },
    openFullScreen() {
      const v = this.$refs.videoPlayer
      if (v.webkitRequestFullScreen) {
        v.webkitRequestFullScreen()
      } else if (v.webkitSupportsFullscreen) {
        v.webkitEnterFullscreen()
      }
    },
    closeFullScreen() {
      const v = this.$refs.videoPlayer
      if (v.webkitSupportsFullscreen && v.webkitDisplayingFullscreen) {
        v.webkitExitFullscreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    },
    showVideo() {
      this.displayVideo = true
    },
    hideVideo() {
      this.displayVideo = false
    },
    showLoading() {
      this.isLoading = true
    },
    hideLoading() {
      this.isLoading = false
    },
    showError() {
      this.isError = true
    },
    hideError() {
      this.isError = false
    },
    showDashBoard() {
      this.hasDashBoard = true
    },
    hideDashBoard() {
      this.hasDashBoard = false
    }
  }
}
</script>

<style lang="scss" scoped>
.kf-player {
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
  overflow: hidden;

  .video-player {
    width: 100%;
    height: 100%;
    position: absolute;
    padding: 0;
    margin: 0;
    z-index: 1;

    video {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;

      &.hide {
        display: none;
      }
    }
  }
  .video-play-button,
  .video-poster {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .video-poster {
    display: flex;
    align-items: center;
    left: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .video-play-button {
    left: 0;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 1rem;
      height: 1rem;
    }
    .icon-play {
      color: #fff;
      font-size: 60px;
    }
  }
  .video-mask-trigger {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 70;
  }
  .video-dashboard {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 40px;
    z-index: 90;
    opacity: 1;
    // background: rgba(0,0,0,.5);
    background-image: url('../../../assets/images/video-control-bg.png');
    background-size: cover;
    transition: all 0.3s ease;

    .iconfont {
      font-size: 18px;
      color: #fff;
    }
    .icon-play {
      font-size: 22px;
    }
    .video-pause,
    .video-play {
      margin-left: 10px;
      margin-right: 10px;
    }
    .video-progress {
      flex: 1;
      display: inline-flex;
      color: #fff;
      font-size: 10px;
      position: relative;
      align-items: center;

      .video-alltime,
      .video-playtime {
        display: inline-block;
        width: 30px;
        text-align: center;
      }

      .video-progress-track {
        flex: 1;
        position: relative;
        height: 3px;
        border-radius: 1.5px;
        background: rgba(255, 255, 255, 0.5);
        margin: 0 8px;

        .progress-play {
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 0;
          background: #ff4e1f;
          border-radius: 1.5px;
        }
        .seekBtn {
          position: absolute;
          display: block;
          width: 11px;
          height: 11px;
          right: 0;
          top: -3px;
          background: 0 0 !important;

          &::after {
            content: '';
            width: 11px;
            height: 11px;
            background: #fff;
            position: absolute;
            right: 0;
            top: 50%;
            left: 6px;
            margin: -6px 0 0;
            border-radius: 50%;
          }
        }
      }
    }
    .video-sound {
      margin: 0 5px;
      display: none;
      // font-size: 16p
    }
    .video-fullscreen {
      margin-left: 10px;
      margin-right: 10px;
      .icon-full {
        font-size: 16px;
      }
    }
  }
  .video-hidden {
    display: none !important;
  }

  .video-opacity-hidden {
    opacity: 0 !important;
  }
  .video-loading {
    position: relative;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 90;

    .loader {
      position: relative;
      margin: 0 auto;
      width: 50px;
      height: 100%;
      &:before {
        content: '';
        display: block;
        padding-top: 100%;
      }
    }
  }
  .video-error {
    position: relative;
    height: 100%;
    color: #fff;
    z-index: 90;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
  }

  .circular {
    animation: rotate 2s linear infinite;
    height: 100%;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
    stroke: #fff;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
}
</style>
